/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import { theme } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { ColumnProps } from "~/components/Tables/types";
import { ServiceCommitment } from "~/models";
import { ROUTES } from "~/routing";

export const ServiceCatalogListColumns: ColumnProps<ServiceCommitment>[] = [
  {
    Header: "Name",
    accessor: "name",
    width: "90%",
    Cell: ({ row }) => (
      <Link
        css={{ color: theme.color.text.text01 }}
        to={`${ROUTES.serviceCommitments.index}/${row.original.id}`}
      >
        {row.original?.name}
      </Link>
    ),
  },
  {
    Header: "Version",
    accessor: "version",
    center: true,
    Cell: ({ row }) => (
      <FlexContainer width="5rem" justify="center">
        {row.original?.version || "-"}
      </FlexContainer>
    ),
  },
];
